module.exports = __webpack_public_path__ + "media/images/file-icons/64/005-database-da5b11b4da71304eb2399731350b6a22.png";